import { fetchGlossaryTerms } from '@app/services/strapiServices'
import { useQuery } from '@tanstack/react-query'

export const useFetchGlossaryTerms = () => {
  return useQuery({
    queryKey: ['glossaryTerms'],
    queryFn: () => fetchGlossaryTerms(),
  })
}
